// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import "./pano2vr_player.js";
require("./pano2vr_skin_module.js");

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class CWInteriorSpinWidget extends ModuleBase {
  public iModuleId: string = "";
  public nElement;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public createUniqueId() {
    let text = "",
      possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
      len = 8;

    for (let i = 0; i < len; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return `interior-spin-module-${text}`;
  }

  public windowResizeEvent() {
    if (!this.nElement) this.nElement = document.getElementById(this.iModuleId);
    this.nElement.style.height = window.innerHeight - 216 + "px";
  }

  public created() {
    this.iModuleId = this.createUniqueId();
  }

  public mounted() {
    if (this.instance["tiles"] && this.instance["tiles"]["panoxml"]) {
      this.windowResizeEvent();
      window.addEventListener("resize", this.windowResizeEvent);

      var pano = new window["pano2vrPlayer"](this.iModuleId);
      var skin = new window["pano2vrSkin"](pano);
      pano.readConfigUrlAsync(this.instance["tiles"].panoxml);
    }
  }

  public destoyed() {
    window.removeEventListener("resize", this.windowResizeEvent);
  }
}
